var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-wrapper"},[_c('div',{staticClass:"nav-bottom flex flex-pack-around"},[_c('i',{staticClass:"iconfont icon-back",on:{"click":_vm.goBack}}),_vm._v(" "),_c('router-link',{staticClass:"iconfont icon-home",attrs:{"tag":"i","to":{ name:'Home' }}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c7899e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom.vue
// module id = null
// module chunks = 